import { IController } from 'angular';
import * as _ from 'lodash';

import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

export class ReadinessMathTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents; // modified students
  public collegeReadinessAlgStudentData;
  public totalStudentsWithReadinessMismatch: number;
  public options: IWizardFilterActionsOptions;
  public patches;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.collegeReadinessAlgStudentData = this.getCollegeReadinessAlgStudentData();
    this.totalStudentsWithReadinessMismatch = this.WizardUtils.getCountOfStudentsToBePatched(
      this.collegeReadinessAlgStudentData,
    );
    this.patches = this.WizardUtils.getRegentsExamBulkPatch(this.collegeReadinessAlgStudentData, 'humanName');

    this.options = {
      columnKeys: [
        'regentsNeededForCollegeReadiness',
        'maxScoreMath',
        'collegeReadyOnMathRegentsOrSatMath',
        'regentsNeededForOnTrackDiploma',
        'regentsSchedForNextAdmin',
      ],
    };
  }

  private getCollegeReadinessAlgStudentData() {
    const baseObj = { 'CC Algebra': { _ids: [], studentIds: [] } };
    return _.reduce(
      this.filteredStudents,
      (studentRecRatCollection, { _id, studentId, isRegentsRecRatCollegeReadinessMismatchedAlg }) => {
        if (isRegentsRecRatCollegeReadinessMismatchedAlg) {
          studentRecRatCollection['CC Algebra']._ids.push(_id);
          studentRecRatCollection['CC Algebra'].studentIds.push(studentId);
        }
        return studentRecRatCollection;
      },
      baseObj,
    );
  }
}
